import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { SweepParticipantsTable } from '../../../../../../../../../../features/sweeps/clearing/participant/sweep-participants-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/participant/_participant/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsSweeps,
      label: 'Participants',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsSweeps>,
  head: () => getPageHead('Sweep Participants'),
  component: SweepParticipantList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsSweeps}
    />
  );
}

function SweepParticipantList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <SweepParticipantsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
